import { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setModal, setSelectionType } from '../../../../Features/storefrontSlice';

function MobileBanner() {
    const dispatch = useDispatch();

    const mediaContainerRef = useRef(null);

    const [bannerHeight, setBannerHeight] = useState(0);

    const zoomSize = useSelector((state) => state.storefront.zoomSize);
    const { storefront } = useSelector((state) => state.storefront.storefront);

    const [logoWidth, setLogoWidth] = useState(0);

    const [addLogoText, setAddLogoText] = useState(0);
    const [addLogoLead, setAddLogoLead] = useState(0);

    const versionStack = useSelector((state) => state.storefront.versionStack);
    const versionIndex = useSelector((state) => state.storefront.versionIndex);

    useEffect(() => {
        setLogoWidth((zoomSize/100)*100);

        setAddLogoText((zoomSize/100)*14);
        setAddLogoLead((zoomSize/100)*22);
    }, [zoomSize]);

    function handleLogoChange() {
        dispatch(setSelectionType('LOGO'));
        dispatch(setModal('media-files'));
    }

    useEffect(() => {
        const updateHeight = () => {
            if (mediaContainerRef.current) {
                setBannerHeight((576 / 1080) * mediaContainerRef.current.clientWidth);
            }
        };

        const resizeObserver = new ResizeObserver(() => {
            updateHeight();
        });
    
        if (mediaContainerRef.current) {
            resizeObserver.observe(mediaContainerRef.current);
        }
    
        updateHeight();
    
        return () => {
            resizeObserver.disconnect();
        };
    }, []);

    return (
        <div ref={mediaContainerRef} className="w-full bg-[#868686] relative -mt-[50px]">
            {
                versionStack[versionIndex]?.backgroundImage ? 
                <img style={{ height: `${bannerHeight}px` }} className='w-full' src={versionStack[versionIndex]?.backgroundImage} alt="" /> : 
                <div style={{ height: `${bannerHeight}px` }} className="w-full"></div>
            }

            {
                (versionStack[versionIndex]?.logoImage?.length > 0 || storefront?.Logo.length > 0) ? 
                <div style={{ width: `${logoWidth}px`, bottom: `-${logoWidth/2}px` }} className="rounded-full overflow-hidden absolute left-1/2 -translate-x-1/2">
                    <img src={versionStack[versionIndex]?.logoImage || storefront?.Logo} alt="" />
                </div> :
                <button onClick={handleLogoChange} style={{ width: `${logoWidth}px`, height: `${logoWidth}px`, bottom: `-${logoWidth/2}px` }} className="outline-none rounded-full overflow-hidden absolute left-1/2 -translate-x-1/2 bg-[#EAEAEA] flex items-center justify-center">
                    <p style={{ fontSize: `${addLogoText}px`, lineHeight: `${addLogoLead}px` }} className='text-[#1055EB] font-semibold'>Add Logo</p>
                </button>
            }
        </div>
    );
}

export default MobileBanner;
